import { render, staticRenderFns } from "./HouseSearch.vue?vue&type=template&id=64da71d8"
import script from "./HouseSearch.vue?vue&type=script&lang=js"
export * from "./HouseSearch.vue?vue&type=script&lang=js"
import style0 from "./HouseSearch.vue?vue&type=style&index=0&id=64da71d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports